import { makeVar } from '@apollo/client';
import { Sigma } from 'sigma';

// keeping just in case for now. But better to store all options in URL as searchparams
// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export type SigmaOptions = {};

export const sigmaOptionsVar = makeVar<SigmaOptions>({
  // edgeDirection: 'out',
});

export const sigmaInstanceVar = makeVar<Sigma | null>(null);

const refreshSigma = () => {
  const sigma = sigmaInstanceVar();

  if (!sigma) return;

  sigma.scheduleRefresh();
};

sigmaOptionsVar.onNextChange(function onNext() {
  refreshSigma();
  sigmaOptionsVar.onNextChange(onNext);
});
